(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["ovp"] = factory();
	else
		root["pakhshkit"] = root["pakhshkit"] || {}, root["pakhshkit"]["providers"] = root["pakhshkit"]["providers"] || {}, root["pakhshkit"]["providers"]["ovp"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition


// WEBPACK FOOTER //
// providers/webpack/universalModuleDefinition